import React from 'react';
import Avatar from 'common/components/avatar';
import { MINI_PROJECT_SUBCAT_NAME } from 'pap/constants';

/**
 * Simple header that displays 1-1 sub-category and creative information.

 * @author Nathan Ozelim <nathan@startupfoundry.com>
 */
const CreativeHeader1to1 = ({ subcatName, creative }) => (
  <div className="one-to-one-creative-header">
    { subcatName === MINI_PROJECT_SUBCAT_NAME?
    <p>{ MINI_PROJECT_SUBCAT_NAME } project with:</p> :
    <p>1-to-1 { subcatName.replace('1-to-1', '') } project with:</p> }
    <Avatar user={creative} extraClasses="avatar-sm"/> <h4>{ creative.username }</h4>
  </div>
)

export default CreativeHeader1to1;



// WEBPACK FOOTER //
// ./common/components/creative_header_1_1.jsx